<template>
  <div class="app-container">
    <!-- 内容区域 -->
    <div class="content">
      <keep-alive>
        <component :is="currentView" class="tab-content"></component>
      </keep-alive>
    </div>

    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div 
        v-for="(tab, index) in tabs"
        :key="index"
        class="nav-item"
        :class="{ 'active': currentTab === index }"
        @click="switchTab(index)"
      >
        <div class="nav-icon">
          <i :class="tab.icon"></i>
        </div>
        <div class="nav-text">{{ tab.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import HomePage from './MoblieHome.vue';
import ShopInfo from './MoblieShopInfo.vue';
import WarrantyCard from './MoblieCard.vue';

export default {
  name: 'App',
  components: {
    HomePage,
    ShopInfo,
    WarrantyCard
  },
  data() {
    return {
      currentTab: 0,
      tabs: [
        { name: '主页', icon: 'el-icon-s-home', component: 'HomePage' },
        { name: '门店分布', icon: 'el-icon-s-shop', component: 'ShopInfo' },
        { name: '质保卡', icon: 'el-icon-document', component: 'WarrantyCard' }
      ]
    }
  },
  computed: {
    currentView() {
      return this.tabs[this.currentTab].component
    }
  },
  methods: {
    switchTab(index) {
      this.currentTab = index
    }
  }
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  overflow: hidden;
}

.app-container {
  max-width: 100%;
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
}

/* 内容区域 */
.content {
  flex: 1;
  overflow-y: auto;
  padding: 0px;
}

.tab-content {
  height: 100%;
}

.page-content {
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page-content h1 {
  color: #303133;
  font-size: 24px;
  margin-bottom: 20px;
}

.page-content p {
  color: #606266;
  font-size: 16px;
  line-height: 1.6;
}

/* 底部导航 */
.bottom-nav {
  display: flex;
  height: 70px;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 10;
}

.nav-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  transition: all 0.3s ease;
  cursor: pointer;
  color: #909399;
}

.nav-item.active {
  color: #409EFF;
}

.nav-icon {
  font-size: 22px;
  margin-bottom: 4px;
}

.nav-text {
  font-size: 12px;
  transform: scale(0.9);
  transition: all 0.3s ease;
}

.nav-item.active .nav-text {
  transform: scale(1);
  font-weight: 500;
}

/* 动画效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 元素微调 */
.el-button {
  border-radius: 20px;
  padding: 10px 25px;
  margin-top: 15px;
}
</style>